export default {
  formatAddressTown (address: string, town: string) {
    const reg = new RegExp(town, 'gi')
    return address.replace(reg, town)
  },
  extractHouseNumber (street: string) {
    const data = street.split(' ')

    if (data && data.length > 0) {
      if (!isNaN(parseInt(data[0]))) return data[0]

      const rangeHouseNumber = data[0].split('-')

      if (rangeHouseNumber && rangeHouseNumber.length > 1) {
        return rangeHouseNumber.join('-')
      } else {
        const matches = data[0].match(/\d+/g)
        if (matches != null) return data[0]

        return ''
      }
    } else {
      return ''
    }
  },
  extractFlatNumber (property: string) {
    const data = property.split(' ')

    if (data && data.length > 0) {
      let i = -1

      data.forEach((d, index) => {
        d.toLowerCase().trim() === 'flat' ? i = index : null
      })

      if (i > -1) {
        return data[i + 1]
      }

      return ''
    } else {
      return ''
    }
  },
  mapStreet (street: string) {
    if (!street) return street
    const data = street.split(' ')

    if (data && data.length > 0 && (!isNaN(parseInt(data[0])) || data[0].match(/\d+/g))) {
      data.splice(0, 1)
      return data.join(' ')
    }

    return street
  }
}

export const postcodeRegex = /^(([A-Z]{1,2}[0-9][A-Z0-9]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?[0-9][A-Z]{2}|BFPO ?[0-9]{1,4}|(KY[0-9]|MSR|VG|AI)[ -]?[0-9]{4}|[A-Z]{2} ?[0-9]{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$/
